var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");
var dot = require("./lib/dot");
var tableTemplate = dot.compile($.one("#table-template").innerHTML);
var pymChild;

pym.then((child) => {
  child.sendHeight();
  pymChild = child;

  window.addEventListener("resize", () => child.sendHeight());
});

console.clear();
var data = window.DATA;
var controls = $.one(".controls");
var stateList = $.one("#state-drop");
var chargeList = $.one("#charges-drop");
var statusList = $.one("#status-drop");
var newCheck = $.one("#new-updated");
var affilList = $.one("#affiliations");
var searchBox = $.one("#search");
var tableContainer = $.one(".table-container");

var params = new URLSearchParams(window.location.search);
[...params.keys()].forEach(k => controls.classList.add("preset-" + k));

// check params passed in from story page
var initChargeFilter = false;
var loc = params.get("parentUrl").split("?")[1];
if (loc) {
  loc = loc.split("#")[0];
}
var pageParams = new URLSearchParams("?" + loc);
// console.log(Object.fromEntries(params));
// console.log(Object.fromEntries(pageParams));

// various filter functions
var filterByState = function (state, list) {
  if (params.has("state")) {
    var states = params.get("state").split(/,\s*/g);
    return list.filter(r => states.includes(r.state));
  }
  if (!state) {
    return list;
  }
  // console.log(list);
  return list.filter((r) => r.state == state);
};

var filterByCaseStatus = function(status, list) {
  if (!status) {
    return list;
  }

  return list.filter(r => r.case_status == status);
};

var filterByCharge = function (charge, list) {
  if (!initChargeFilter && pageParams.has("charge") && pageParams.get("charge") == "violent") {
    charge = "violence_assault";
    chargeList.value = charge;

    // only do this on initial render
    initChargeFilter = true;

    return list.filter(function (row) {
      return row[charge];
    });
  }

  if (!charge) {
    return list;
  }
  return list.filter(function (row) {
    return row[charge];
  });
};

var filterByNewUpdated = function (checked, list) {
  if (checked.length == 0) {
    return list;
  }

  if (checked.includes("new")) {
    checked.push("updated");
  }
  return list.filter(function(row) {
    return checked.some((r) => row[r]);
  })
}

var filterbyAffiliation = function (affil, list) {
  return list.filter(function (row) {
    return affil.every((r) => row[r]);
  });
};

var filterBySearch = function (query, list) {
  if (!query) {
    return list;
  }
  var re = new RegExp(query, "i");
  // console.log(re); 
  return list.filter(
    (r) =>
      r.summary.match(re) ||
      (Boolean(r.state) && r.state.match(re)) ||
      r.first.match(re) ||
      r.last.match(re) ||
      (Boolean(r.city) && r.city.match(re)) || (Boolean(r.case_updates) && r.case_updates.match(re)) || (Boolean(r.charges) && r.charges.match(re))
  );
};

var chainFilters = function () {
  var affilChecked = $(
    ".affiliations input[type=checkbox]:checked",
    affilList
  ).map((el) => el.getAttribute("value"));

  var newUpdatedChecked = $(
    ".check input[type=checkbox]:checked",
    newCheck
  ).map((el) => el.getAttribute("value"));

  var filters = [
    { filter: filterByState, value: stateList.value },
    { filter: filterByCharge, value: chargeList.value },
    { filter: filterByCaseStatus, value: statusList.value },
    { filter: filterByNewUpdated, value: newUpdatedChecked },
    { filter: filterbyAffiliation, value: affilChecked },
    { filter: filterBySearch, value: searchBox.value }
  ];

  var rows = data;
  filters.forEach((def) => (rows = def.filter(def.value, rows)));
  // sort alphabetically by new, then updated, then remaining
  rows.sort(function(a, b) {
    var newA = a.new === "" ? 0 : 1;
    var newB = b.new === "" ? 0 : 1;

    var updatedA = a.updated === "" ? 0 : 1;
    var updatedB = b.updated === "" ? 0 : 1;

    var nameA = a.last.toLowerCase();
    var nameB = b.last.toLowerCase();

    return newB - newA || updatedB - updatedA || nameA.localeCompare(nameB);
  })
  // console.log(rows)
  // console.log(searchBox.value, rows);
  var labels = window.LABELS;
  var filterString = "";
  if (params.has("state")) {
    var states = params.get("state").split(/,\s*/);
    var words = [];
    for (var i = 0; i < states.length; i++) {
      words.push(states[i]);
      if (i < states.length - 2) words.push(", ");
      if (i == states.length - 2) words.push(" and ");
    }
    var joined = words.join("");
    filterString = ` in ${joined}`;
  }
  tableContainer.innerHTML = tableTemplate({ rows, labels, filterString });

  $(".excessive").forEach(function(cell) {
    var button = $.one(".show-more", cell);
    if (button) {
      cell.classList.add("collapsed");
      button.addEventListener("click", function() {
        cell.classList.toggle("collapsed");
        var collapsed = cell.classList.contains("collapsed");
        button.innerHTML = collapsed ? "Show More &#9660;" : "Show Less &#9650;";

        if (pymChild) {
          pymChild.sendHeight();
        }
      });
    }
  });

  if (pymChild) {
    pymChild.sendHeight();
  }
};

chainFilters();

var debounce = require("./lib/debounce");

var debounceFilters = debounce(chainFilters);
controls.addEventListener("input", debounceFilters);
